{
  "booking_confirmed": {
    "body": "היי {name}, התור שלך ב-{business} נקבע ✅\n{service} · {date}, {time}\nלשינוי או ביטול: {link}",
    "cta": "ניהול התור"
  },
  "reminder_24h": {
    "body": "היי {name}, תזכורת לתור שלך ב-{business}: {service}, {date} בשעה {time}.\nלהזזה או ביטול: {link}",
    "cta": "הזיזו או בטלו"
  },
  "rescheduled": {
    "body": "היי {name}, התור שלך ב-{business} הוזז.\nהמועד החדש: {service}, {date} בשעה {time}.\nלשינוי נוסף: {link}",
    "cta": "ניהול התור"
  },
  "cancelled_by_owner": {
    "body": "היי {name}, התור ב-{business} ({service}, {date}, {time}) בוטל. סליחה על אי הנוחות.\nלבחירת מועד אחר: {link}",
    "cta": "בחרו מועד אחר"
  },
  "cancelled_by_client_ack": {
    "body": "היי {name}, קיבלנו את הביטול של התור ב-{business} ({service}, {date}, {time}).\nלקביעת תור חדש: {link}",
    "cta": "קבעו תור חדש"
  },
  "waitlist_offer": {
    "body": "היי {name}, התפנתה שעה ב-{business}: {service}, {date} בשעה {time}.\nההצעה נשלחה לכל הממתינים והראשון שמאשר קובע: {link}\nבתוקף ל-30 דקות.",
    "cta": "אשרו את השעה"
  },
  "waitlist_offer_taken": {
    "body": "היי {name}, השעה ({date}, {time}) ב-{business} כבר נתפסה.\nהבקשה שלך נשארת ברשימת ההמתנה, ונעדכן כשתתפנה שעה אחרת."
  },
  "deposit_request": {
    "body": "היי {name}, כדי לשריין את התור ב-{business} ({service}, {date}, {time}) נדרשת מקדמה.\nלתשלום תוך 15 דקות: {link}\nאחרי הזמן הזה השעה תשוחרר.",
    "cta": "שלמו מקדמה"
  },
  "deposit_received": {
    "body": "היי {name}, המקדמה התקבלה והתור שלך ב-{business} אושר ✅\n{service} · {date}, {time}\nלשינוי או ביטול: {link}",
    "cta": "ניהול התור"
  },
  "deposit_expired": {
    "body": "היי {name}, לא קיבלנו את המקדמה בזמן והשעה ({date}, {time}) ב-{business} שוחררה.\nלקביעה מחדש: {link}",
    "cta": "קבעו שוב"
  },
  "manual": {
    "reminder": "היי {name}, תזכורת לתור ב-{business}: {service}, {date} בשעה {time}.",
    "hello": "היי {name}, כאן {business}."
  },
  "preview": {
    "header": "{business}",
    "template": "תבנית: {template}"
  },
  "deposit_claimed_owner": {
    "body": "התקבל דיווח על מקדמה ב-{method} מ{name} עבור {service}, {date} בשעה {time}.\nבדקו שההעברה הגיעה ואשרו באפליקציה.",
    "cta": "אישור תשלום"
  },
  "business_closed": {
    "body": "היי {name}, התור ב-{business} בוטל: {service}, {date} בשעה {time}.\nהעסק סגר את הדף שלו ב-Planella. אפשר ליצור איתו קשר ישירות."
  }
}
